import * as React from "react"
const SvgTextStrikethrough = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.238 19.448a5.4 5.4 0 0 0 2.912.838q2.075 0 3.637-1.263 1.563-1.262 1.563-3.237v-.3q0-.5-.363-.85a1.2 1.2 0 0 0-.862-.35q-.5 0-.85.35t-.35.85q0 1.05-.813 1.725t-1.912.675q-.875 0-1.637-.45a3.4 3.4 0 0 1-1.213-1.2 1.38 1.38 0 0 0-.762-.613 1.12 1.12 0 0 0-.938.088q-.425.224-.588.662a.96.96 0 0 0 .063.838 6.05 6.05 0 0 0 2.113 2.237m-6.95-7.45a.97.97 0 0 0 .712.288h18q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287H9.725a3.2 3.2 0 0 1-.251-1.246c0-.513.133-.942.376-1.38a1.97 1.97 0 0 1 .95-.85 3.2 3.2 0 0 1 1.3-.274q.575 0 1.075.2t.875.625q.35.4.837.475.488.075.913-.225.375-.276.475-.725a.91.91 0 0 0-.175-.8 4.8 4.8 0 0 0-1.788-1.45 5.25 5.25 0 0 0-2.262-.5q-1.35 0-2.525.6t-1.8 1.775c-.449.763-.651 1.703-.651 2.579q0 .616.125 1.196H3a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.712" />
  </svg>
)
export default SvgTextStrikethrough
